var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreakfast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20280_301606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#B1B6EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.9 318C416.7 333.2 416.7 357.9 431.9 373L500 441.1V500H0V206.7C14.4 213.5 32.1 210.9 44 199L243 0H359L500 141.1V250L431.9 318Z",
    fill: "#BAC2F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9 430.5C342.1 418.7 366 400.3 384.1 377.8C421.6 331.2 423.7 273.4 405.6 218.2C402.4 208.4 398.4 198.1 394.3 188.7C342.2 70.3 184.2 70.7 108.3 165.6C87.9999 190.3 74.2999 220 66.9999 251C66.8999 251.6 66.1999 252 65.5999 251.9C64.9999 251.8 64.5999 251.1 64.6999 250.5C70.2999 218.4 82.6999 187.3 102 160.8C161.8 76.6 287.6 50.3 370.8 116.2C398.6 138 417.5 167 430.1 199.7C457.3 266.6 457.4 340.1 412.7 399.7C391.8 427.6 364.3 450.5 333.1 466C322.9 471.6 309.8 467.2 305.3 456.4C301.1 446.3 305.8 434.7 315.9 430.5Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.22 418.639C345.49 414.606 416.508 381.458 414.843 344.603C413.178 307.747 339.46 281.139 250.19 285.172C160.919 289.205 89.9014 322.352 91.5665 359.208C93.2316 396.064 166.949 422.672 256.22 418.639Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.4002 287.8C89.9002 239.7 166.7 205.3 246.4 201.7C326.1 198.1 405.6 225.5 428.4 271.6C458.1 331.7 384.8 400.3 255.6 406.1C126.4 411.9 47.3002 350.3 71.4002 287.8Z",
    fill: "#A6A5C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1001 280.5C89.6001 232.4 166.4 198 246.1 194.4C325.8 190.8 405.3 218.2 428.1 264.3C457.8 324.4 384.5 393 255.3 398.8C126.1 404.6 47.0001 343.1 71.1001 280.5Z",
    fill: "#FEFAE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6001 277.1C109 236.9 176.5 208 246.5 204.8C316.5 201.6 386.4 224.4 406.3 262.9C432.2 313.1 367.8 370.6 254.2 375.7C140.6 380.8 71.3001 329.4 92.6001 277.1Z",
    fill: "#E7E6C9"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.747 259.592C156.43 258.251 180.204 250.768 179.847 242.878C179.491 234.988 155.139 229.679 125.456 231.02C95.7725 232.361 71.9984 239.844 72.3549 247.734C72.7114 255.624 97.0633 260.933 126.747 259.592Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81 271.6C80 278.3 71.8 278.2 69.5 271.4C65.4 259.2 59.8 238.9 63.5 226.6C69.2 207.7 77.2 200.4 108 188.9C138.8 177.4 153.5 180.3 163.7 186.4C186.8 200 192.6 224.5 188.8 228.6C184.8 232.9 181 220.7 164.3 222C144.8 223.5 131.5 220 115.3 233.7C99 247.4 92.8 254.1 84.5 263.8C81.8 267.1 81.3 269.5 81 271.6Z",
    fill: "#E09534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1001 206.9C61.5001 212.4 68.7001 229.1 75.1001 237.6C89.7001 257.1 89.9001 256.4 120.2 241.6C150.5 226.8 162.2 232.5 164 225.6C166.4 216.6 159.2 176 147.9 176.1C136.7 176.1 82.3001 191.9 67.1001 206.9Z",
    fill: "#EAA542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6001 193.6C84.6001 193.6 79.3001 198.2 83.4001 209.6C87.4001 221 110.5 255.2 125 245.9C139.5 236.6 148.8 235.9 148.5 229.1C148.1 220.2 138.9 179.6 132.4 177.4C125.9 175.1 84.6001 193.6 84.6001 193.6Z",
    fill: "#F4B651"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.021 360.071C322.256 357.982 359.058 341.26 358.22 322.722C357.383 304.184 319.223 290.849 272.988 292.938C226.753 295.027 189.95 311.748 190.788 330.287C191.626 348.825 229.786 362.16 276.021 360.071Z",
    fill: "#FEFCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.9 319.9C317.2 326.8 312 333.1 303.9 336.8C299.6 338.8 294.4 340.1 288.9 340.3C272.9 341 259.6 333 259.2 322.5C259.2 322.4 259.2 322.3 259.2 322.2C259 311.8 271.4 302.8 287.2 302.1C303.1 301.4 316.4 309.3 316.9 319.9Z",
    fill: "#FFD21E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.526 319.003C299.443 318.826 302.52 316.491 302.398 313.787C302.276 311.084 299.001 309.036 295.084 309.213C291.166 309.39 288.09 311.725 288.212 314.428C288.334 317.132 291.609 319.18 295.526 319.003Z",
    fill: "#FCFAEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.9 336.8C299.6 338.8 294.4 340.1 288.9 340.3C272.9 341 259.6 333 259.2 322.5C259.2 322.4 259.2 322.3 259.2 322.2C260.4 322.9 261.4 323.8 262 325C267.6 335.4 286.4 336.8 303.9 336.8Z",
    fill: "#FDBD1D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.952 287.09C376.917 286.143 393.625 278.979 393.268 271.089C392.912 263.199 375.627 257.571 354.661 258.518C333.695 259.466 316.988 266.629 317.344 274.519C317.701 282.409 334.986 288.037 355.952 287.09Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.8 279.1L348.5 278.1C335.3 277.5 324.9 266.2 325.6 252.9L330.8 140.7C330.9 139.5 331.9 138.5 333.2 138.5L398.1 141.5C399.3 141.6 400.3 142.6 400.3 143.9L395.1 256.1C394.3 269.4 383 279.7 369.8 279.1Z",
    fill: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2 271.7L350.7 270.9C339.8 270.4 331.3 261.1 331.8 250.2L336.2 156.1L393.3 158.7L388.9 252.8C388.4 263.7 379.1 272.2 368.2 271.7Z",
    fill: "#FFA500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.8 165.4L338 163C336.8 162.9 335.9 161.9 336 160.8L336.3 154.9L393.4 157.5L393.1 163.4C393 164.6 392 165.5 390.8 165.4Z",
    fill: "#FFBD1E"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.2 236.8C378.4 236.7 376.3 234.3 376.4 231.5L380.2 148.8C380.3 146 382.7 143.9 385.5 144C388.3 144.1 390.4 146.5 390.3 149.3L386.5 232C386.3 234.8 383.9 237 381.2 236.8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.849 257.889C284.732 256.765 304.615 249.457 304.258 241.568C303.902 233.678 283.441 228.193 258.558 229.318C233.675 230.442 213.792 237.749 214.148 245.639C214.505 253.529 234.966 259.013 259.849 257.889Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M293.1 158C289.8 145.7 267.4 140.5 241 147.5C214.6 154.5 197.5 169.1 200.8 181.4L225.7 235.5C228.2 244.8 246.4 248.1 266.4 242.7C286.4 237.3 300.6 225.5 298.1 216.2L293.1 158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 156.2C288.3 157.4 288.4 158.6 288.2 159.9C287 169.8 271.7 181.1 251.3 186.5C230.9 191.9 212 189.7 206 181.8C205.2 180.8 204.7 179.7 204.4 178.5C201.6 167.9 218 154.3 241.1 148.2C264.2 142.1 285.2 145.6 288 156.2Z",
    fill: "#64327A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.3 159.9C287.4 167.2 278.8 175.5 266 181.6C261.6 183.7 256.7 185.5 251.5 186.9C248.4 187.7 245.3 188.4 242.3 188.8C231.1 190.6 221 189.9 214 187.2C210.6 185.9 207.9 184.1 206.2 181.9C209.8 178 212.2 174.6 217.3 171C222.6 167.3 227.1 163.8 243 156.6C263.2 147.2 289 146.9 288.3 159.9Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5 206.8L294.1 210.9C292.9 211.2 291.6 211.1 290.6 210.5C289.6 209.9 289 209 288.9 208L285.8 172.3C285.6 170.5 287.1 168.8 289.1 168.2L304 164.2C305.2 163.8 309 162.8 312.6 164.3C314.6 165.1 317.2 167 318.4 171.2C320.2 177.8 318.6 192.6 317.9 198.7C317.7 200 317.2 201.2 316.3 202.3C315 203.8 312.7 205.9 309.5 206.8ZM297 202.6L307.6 199.8C308 199.7 308.7 199.3 309.4 198.4C310.5 189.7 311.3 177.9 310 173.4C309.7 172.1 309.1 171.3 308.5 171C307.7 170.6 306.4 171 306.4 171C306.2 171.1 306.2 171.1 306 171.1L294.5 174.2L297 202.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.7 160C251.3 160 250.8 159.8 250.6 159.3C250.3 158.7 250.5 157.9 251.1 157.6C266.2 149.7 277 155.3 277.4 155.5C278 155.8 278.2 156.6 277.9 157.2C277.6 157.8 276.8 158 276.2 157.7C276.1 157.6 266 152.6 252.2 159.8C252.1 160 251.9 160 251.7 160Z",
    fill: "#F8F9FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M125.1 366.1C126.3 373.7 117.3 376.4 112.5 369.9C103.8 358 90.8 337.8 90.6 323.2C90.3 300.7 96.5 289.9 126.2 266.8C155.9 243.7 172.9 241.9 186.1 244.9C216 251.8 230.7 276.5 228 282.2C225.1 288.3 216.8 276.3 199.1 283.4C178.4 291.7 162.7 292.4 149.7 313C136.7 333.6 132.1 342.9 126.5 356.4C124.5 361 124.7 363.7 125.1 366.1Z",
    fill: "#E09534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8 300.4C83.6 308.3 97.2 324.1 107 331.2C129.7 347.4 129.5 346.6 157.5 320.1C185.5 293.6 200.1 295.8 199.8 287.6C199.4 276.9 177.5 235.2 165.3 239.1C153 242.9 99.2 278.8 87.8 300.4Z",
    fill: "#EAA542"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.2 279.8C102.2 279.8 98.0001 286.6 106.4 297.7C114.7 308.8 151.5 338.1 164.2 323C176.9 307.9 186.7 304 184 296.6C180.5 287 156.6 245.9 148.8 245.7C140.9 245.5 102.2 279.8 102.2 279.8Z",
    fill: "#F4B651"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20280_301606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/Breakfast.3c87ceef.svg";
export { ForwardRef as ReactComponent };